import React, { useEffect, useState } from 'react';
import { Sec2Str, Str2Sec } from '../../helpers/timeHelper';
import { format } from "date-fns";
import BiHelp from './BiHelp';

const BiTimeDTPicker = ({
    name,
    value,
    onChange,
    disabled,
    width,
    format: timeFormat,

    help,
    helpKey,
    helpMainKey

}) => {
    let dod = {
        width: width == null ? "135px" : ((width) + "px"),
        display: "inline-flex",
        alignItems: "center",
        position: "relative"
    }
    const [datePart, setDatePart] = useState("");
    const [time, setTime] = useState("");

    useEffect(() => {
        if (value != null) {
            let val = value;
            
            if (val.length < 10) {
                val = format(new Date(), "yyyy-MM-dd") + val;
            }
            val = val.replace("T0:", "T00:");
            let ix = val.indexOf("T");

           // console.log(val.substring(0, ix));

            setDatePart(val.substring(0, ix));
            setTime(format(new Date(val), timeFormat != null ? timeFormat : "H:mm:ss"));
        } else {
            setTime("");
        }
    }, [value]);

    const onChanged = (e) => {

        if (e.target.value != "" && e.target.value != null) {
            let sec = Str2Sec(e.target.value, timeFormat);

            if (sec > 3600 * 24) {
                sec = 3600 * 24 - 1;
            }
            setTime(Sec2Str(sec, timeFormat))

            if (onChange != null) {
                let dp = datePart;
                if (dp == null || dp == "") {
                    dp = format(new Date(), "yyyy-MM-dd");
                }
                onChange({ target: { name: e.target.name, value: dp + "T" + Sec2Str(sec) } });
            }
        }
        else {
            setTime("")
            if (onChange != null) {
                onChange({ target: { name: e.target.name, value: null} });
            }
        }

        
    }

    return (

          <div  style={dod}>

             <input

                type="text"
                className="form-control form-control-sm"
                name={name}
                disabled={disabled ? "disabled" : ""}
                onBlur={(e) => onChanged(e)}
                onChange={(e) => setTime(e.target.value)}
                value={time} />
            <i className="fas fa-clock"
                style={{
                    position: "absolute",
                    right: ((help == true) ? "23px" : "10px"),
                    color: "#626262"
                }}
            ></i>
            

            {(help == true) &&
                <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
            }
        </div>

    );
}

export default BiTimeDTPicker;

